{
  "meta": {
    "industry": "Finance",
    "fiscalYear": "FY2026",
    "currency": "USD"
  },
  "timing": {
    "typingSpeedMs": 32,
    "thinkingMs": 1300,
    "nudgeDelayMs": 600
  },
  "charts": {
    "aumTrend": {
      "type": "bar",
      "title": "Total AUM by Month ($B)",
      "containerClass": "chartCard",
      "data": [
        { "month": "Jun", "aumB": 3.86 },
        { "month": "Jul", "aumB": 3.94 },
        { "month": "Aug", "aumB": 4.01 },
        { "month": "Sep", "aumB": 4.02 },
        { "month": "Oct", "aumB": 4.11 },
        { "month": "Nov", "aumB": 4.28 }
      ],
      "xKey": "month",
      "yKey": "aumB",
      "barColor": "hsl(202, 100%, 50%)",
      "barRadius": [4, 4, 0, 0],
      "heightPercent": 85,
      "tooltip": { "prefix": "$", "suffix": "B", "decimals": 2 },
      "legend": { "show": true },
      "barName": "AUM ($B)"
    },
    "netFlowsByCategory": {
      "type": "bar-horizontal",
      "title": "Net Flows by Fund Category (Current Month, $M)",
      "containerClass": "chartCardSmall",
      "data": [
        { "category": "Equity", "netFlowM": 72 },
        { "category": "Fixed Income", "netFlowM": 49 },
        { "category": "Multi-Asset", "netFlowM": 31 },
        { "category": "Alternatives", "netFlowM": 18 },
        { "category": "Cash Mgmt", "netFlowM": 14 }
      ],
      "categoryKey": "category",
      "valueKey": "netFlowM",
      "barColor": "hsl(202, 100%, 50%)",
      "barRadius": [0, 4, 4, 0],
      "height": 220,
      "yAxisWidth": 98,
      "tooltip": { "prefix": "$", "suffix": "M", "decimals": 0 }
    },
    "flowMix": {
      "type": "pie",
      "title": "Gross Flow Mix (Current Month)",
      "containerClass": "chartCardSmall",
      "data": [
        { "name": "Inflows", "value": 312, "color": "hsl(202, 100%, 50%)" },
        { "name": "Outflows", "value": 128, "color": "hsl(10, 80%, 50%)" }
      ],
      "tooltip": {
        "prefix": "$",
        "suffix": "M",
        "decimals": 0,
        "includeLabel": true
      },
      "layout": "side",
      "flexClass": "chartFlex chartHeight44",
      "legend": {
        "size": "small",
        "items": [
          { "text": "Inflows: $312M", "color": "hsl(202, 100%, 50%)" },
          { "text": "Outflows: $128M", "color": "hsl(10, 80%, 50%)" }
        ],
        "footer": "Net Inflow: +$184M"
      }
    },
    "netFlowByRiskProfile": {
      "type": "bar-horizontal",
      "title": "Net Inflow by Risk Profile (Current Month, $M)",
      "containerClass": "chartCardSmall",
      "data": [
        { "riskProfile": "Conservative", "netFlowM": 42 },
        { "riskProfile": "Balanced", "netFlowM": 86 },
        { "riskProfile": "Growth", "netFlowM": 56 }
      ],
      "categoryKey": "riskProfile",
      "valueKey": "netFlowM",
      "barColor": "hsl(202, 100%, 50%)",
      "barRadius": [0, 4, 4, 0],
      "height": 180,
      "yAxisWidth": 98,
      "tooltip": { "prefix": "$", "suffix": "M", "decimals": 0 }
    }
  },
  "conversations": [
    {
      "question": "what is our total aum growth across all funds this month",
      "pauseAfterResponseMs": 2400,
      "blocks": [
        {
          "type": "chart",
          "chartId": "aumTrend",
          "delayMs": 1250
        },
        {
          "type": "heading",
          "text": "AUM Snapshot (Current Month)",
          "delayMs": 0
        },
        {
          "type": "list",
          "delayMs": 0,
          "items": [
            "Total AUM: $4.28B",
            "MoM Growth: +6.4%",
            "Net Inflow: +$184M"
          ]
        },
        {
          "type": "paragraph",
          "delayMs": 0,
          "text": "Total AUM reached $4.28B, driven largely by $184M in net inflows. This month's 6.4% growth outperformed the benchmark by 1.2%."
        }
      ]
    },
    {
      "question": "show me the net flows by fund category",
      "pauseAfterResponseMs": 7200,
      "blocks": [
        {
          "type": "chart",
          "chartId": "netFlowsByCategory",
          "delayMs": 1250
        },
        {
          "type": "chart",
          "chartId": "flowMix",
          "delayMs": 2000
        },
        {
          "type": "heading",
          "text": "Institutional Governance",
          "delayMs": 1000
        },
        {
          "type": "paragraph",
          "delayMs": 1000,
          "text": "Sustainable Growth funds saw the highest retention. Note: this view is filtered by your Regional Partner permissions, and APAC data is currently excluded per compliance settings."
        },
        {
          "type": "paragraph",
          "emphasis": "italic",
          "delayMs": 600,
          "text": "Would you like to see a breakdown of AUM by client risk profile?"
        }
      ]
    },
    {
      "question": "yes",
      "blocks": [
        {
          "type": "chart",
          "chartId": "netFlowByRiskProfile",
          "delayMs": 1000
        },
        {
          "type": "heading",
          "text": "Risk Profile Breakdown",
          "delayMs": 0
        },
        {
          "type": "paragraph",
          "delayMs": 0,
          "text": "Monthly net inflows are strongest in Balanced (+$86M), followed by Growth (+$56M) and Conservative (+$42M)."
        }
      ]
    }
  ]
}